import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import Table from '@/common/components/Table'
import { BillingTransactionIdentifier } from '@/common/types/billing/transactionIdentifier.type'
import { CardDetailsData } from '@/features/cards/types/CardDetails.type'
import { EquipmentInfo } from '@/features/refund/components/equipmentInfo'
import { defaultColumns } from '@/features/refund/constants/productsColumns.constant'
import { BillingTransactionIdentifiersTransformer } from '@/features/refund/services/billingTransactionIdentifiersTransformer'
import { FuelIcon } from 'lucide-react'

interface TransactionDataProps {
  transactionIdentifiers: BillingTransactionIdentifier
}

export const TransactionData = ({ transactionIdentifiers }: TransactionDataProps) => {
  return (
    <>
      <div className="w-full space-y-4">
        {transactionIdentifiers?.eventable?.card && (
          <EquipmentInfo
            cardDetails={transactionIdentifiers?.eventable.card as unknown as CardDetailsData}
            companyData={transactionIdentifiers.eventable.company}
            clientBranch={transactionIdentifiers.eventable.client_branch}
          />
        )}
      </div>
      <div className="space-y-2 bg-white-200 rounded-lg p-4">
        <p className="text-[11px] leading-3">Estabelecimento</p>
        <div className="flex items-center gap-2">
          <ImageWithPlaceholder
            url={transactionIdentifiers.eventable?.establishment_branch?.general_information?.company_logo?.url}
            alt={transactionIdentifiers.eventable?.establishment_branch?.general_information?.fantasy_name}
            className="size-6"
            iconClassName="size-4"
            placeholderIcon={FuelIcon}
          />
          <p className="text-sm">
            {transactionIdentifiers.eventable?.establishment_branch?.general_information?.fantasy_name}
          </p>
        </div>
      </div>
      <Table
        columns={defaultColumns}
        isLoadingData={false}
        rows={BillingTransactionIdentifiersTransformer.tableTransformer()(
          transactionIdentifiers.eventable?.line_items || [],
        )}
        page={1}
        totalPages={1}
      />
    </>
  )
}
